<template><div></div></template>
<script>
import { mapGetters, mapState } from 'vuex';

// Roles that must not see the Intercom messenger.
const INTERCOM_HIDDEN_ROLE_LEVELS = ['client-level-3', 'client-sharing-user', 'client-level-4', 'client-level-5'];

    export default {
   name:"Intercom",
	data() {
		return {
			requested: false,
			scriptLoaded: false,
			booted: false,
			stubHandlers: { onShow: [], onHide: [] }
		}
	},
	computed: {
		...mapGetters(['getCurrentRoleLevel']),
		...mapState(['user', 'currentAgreementRoleLevelName']),
		// Hidden if either the account role or the role on the agreement being viewed is restricted.
		// The agreement role isn't reset on logout, so only trust it while signed in.
		isIntercomHidden() {
			return INTERCOM_HIDDEN_ROLE_LEVELS.includes(this.getCurrentRoleLevel?.roleName)
				|| (!!this.user?.uid && INTERCOM_HIDDEN_ROLE_LEVELS.includes(this.currentAgreementRoleLevelName));
		}
	},
	watch: {
		isIntercomHidden() {
			this.syncIntercom();
		}
	},
	methods: {
        // Userflow's Resource Center "Live-chat" button hides the Resource Center, calls
        // Intercom('show') and only brings it back when Intercom fires onHide. For hidden
        // roles the messenger must never open, so we answer every show with an onHide.
        syncIntercom(){
            if (!this.requested) return;
            if (this.isIntercomHidden) {
                if (this.scriptLoaded) {
                    // Real Intercom is already on the page (role changed mid-session):
                    // hide the launcher; the onShow guard closes the messenger if opened.
                    window.Intercom('update', { hide_default_launcher: true });
                    window.Intercom('hide');
                } else {
                    this.installIntercomStub();
                }
                return;
            }
            if (!this.booted) {
                this.appendIntercomScript();
            }
        },
        // Stand-in for Intercom when it was never loaded: records the handlers Userflow
        // registers and fires onHide for any show* call so the Resource Center returns.
        installIntercomStub(){
            if (window.Intercom) return;
            const handlers = this.stubHandlers;
            const stub = function(command, callback){
                if (command === 'onShow' || command === 'onHide') {
                    handlers[command].push(callback);
                } else if (typeof command === 'string' && command.indexOf('show') === 0) {
                    setTimeout(() => handlers.onHide.forEach((fn) => fn()));
                }
            };
            stub.isDiviiStub = true;
            window.Intercom = stub;
        },
        appendIntercomScript(){
            const VUE_APP_INTERCOM_APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;
            if (!this.scriptLoaded) {
            // The loader below skips loading when window.Intercom is already a function.
            if (window.Intercom && window.Intercom.isDiviiStub) {
                delete window.Intercom;
            }
            let headScript = document.createElement('script');
            headScript.innerHTML = `(function(){var w=window;
                                    var ic=w.Intercom;
                                    if(typeof ic==="function"){
                                    ic('reattach_activator');
                                    ic('update',w.intercomSettings);
                                    }else{
                                    var d=document;
                                    var i=function(){
                                    i.c(arguments);
                                    };
                                    i.q=[];
                                    i.c=function(args){i.q.push(args);
                                    };
                                    w.Intercom=i;
                                    var l=function(){var s=d.createElement('script');
                                    s.type='text/javascript';
                                    s.async=true;s.src='https://widget.intercom.io/widget/' + '${VUE_APP_INTERCOM_APP_ID}';
                                    var x=d.getElementsByTagName('script')[0];
                                    x.parentNode.insertBefore(s,x);};
                                    if(document.readyState==='complete'){
                                        l();
                                    }else if(w.attachEvent){
                                        w.attachEvent('onload',l);
                                    }else{
                                        w.addEventListener('load',l,false);
                                    }}})();`
            document.head.appendChild(headScript);
            this.scriptLoaded = true;

            // Userflow registers its handlers only once; hand any it gave the stub to the real Intercom.
            this.stubHandlers.onShow.forEach((fn) => window.Intercom('onShow', fn));
            this.stubHandlers.onHide.forEach((fn) => window.Intercom('onHide', fn));
            window.Intercom('onShow', () => {
                if (this.isIntercomHidden) window.Intercom('hide');
            });
            }

            window.Intercom('boot', {app_id: VUE_APP_INTERCOM_APP_ID});
            this.booted = true;
            }

    },
    mounted(){
        this.$root.$on('appendIntercomScript', () => {
            this.requested = true;
            this.syncIntercom();
    })
    }
};


</script>

